/**
 * Canonical GoHub company facts. Single source of truth.
 * Confirmed 2026-08-09. Do NOT hardcode these figures anywhere else.
 * Raw values live in ./company-facts.json so build scripts can read the same source.
 */
import facts from "./company-facts.json";

export const LAB_COUNT = facts.LAB_COUNT;
export const LAB_COUNT_WORD = facts.LAB_COUNT_WORD;
export const BRAND_COUNT = facts.BRAND_COUNT;
export const BRAND_COUNT_LABEL = facts.BRAND_COUNT_LABEL;
export const BRAND_COUNT_WORD = facts.BRAND_COUNT_WORD;
export const SKU_COUNT_LABEL = facts.SKU_COUNT_LABEL;
export const SKU_COUNT_SHORT = facts.SKU_COUNT_SHORT;
export const SKU_COUNT_WORD = facts.SKU_COUNT_WORD;

/** Common phrasings built from the canonical numbers. */
export const LABS_PHRASE = `${LAB_COUNT} certified optical labs across the EU and US`;
export const CATALOG_PHRASE = `${SKU_COUNT_LABEL} frames from ${BRAND_COUNT_LABEL} brands`;

export const COMPANY_FACTS = {
  LAB_COUNT,
  LAB_COUNT_WORD,
  BRAND_COUNT,
  BRAND_COUNT_LABEL,
  BRAND_COUNT_WORD,
  SKU_COUNT_LABEL,
  SKU_COUNT_SHORT,
  SKU_COUNT_WORD,
  LABS_PHRASE,
  CATALOG_PHRASE,
};
